export const ADMIN_ADD_PRODUCT = "admin/add/product";
